import React, { Fragment, useRef, useState, useEffect } from 'react'
import PopUp from '../Common/PopUp';
import Filter from '../Common/Filter';
import Table from '../Common/Table';
import { showToast } from '../Common/Messages';
import { useSelector } from 'react-redux';

export const usePrevState = (state) => {
    const ref = useRef(state);
    useEffect(() => {
        ref.current = state;
    }, [state]);
    return ref.current;
}

const EditorSetting = (props) => {
    const LoginStates = useSelector(state => state.login);
    const loginUserId = LoginStates.userId;

    const [veiwList, setVeiwList] = useState([]);
    const [userList, setUserList] = useState([]);
    const [filteredUsers, setFilteredUsers] = useState([]);
    const [listTitle, setListTitle] = useState('');
    const [popupContent, setPopupContent] = useState(null);
    const [groupList, setGroupList] = useState([]);
    const [newGroup, setNewGroup] = useState(null);
    const [editingIndex, setEditingIndex] = useState(null);
    const [editName, setEditName] = useState('');
    const [selectedIndex, setSelectedIndex] = useState(-1);
    const [checkedItems, setCheckedItems] = useState(new Set());
    const [isCheckedAll, setIsCheckedAll] = useState(false);

    useEffect(() => {
        fetch (`api/Manager/GetDocumentsBox?id=${loginUserId}`,{
            method: 'GET'
        }).then((response) => response.json())
            .then(data => {            
                setGroupList(data.filter(x => x.docBoxType !== ''));
                setSelectedIndex(1);
            });        

        const handleClickOutside = (e) => {
            if (popupContent 
                && !e.target.closest('.context-menu') 
                && !e.target.classList.contains('kebab-24')
                && !e.target.closest('.btn-admin-more')
                && !e.target.classList.contains('i-btn-more')) {
                setPopupContent(null);
            }
        };
        document.addEventListener('click', handleClickOutside);
        return () => document.removeEventListener('click', handleClickOutside);
    }, []);

    useEffect(() => {
        if (selectedIndex !== -1) {
            if(newGroup && !newGroup.name.trim() && !newGroup.path.trim()) setNewGroup(null);
            const body = {
                docBoxSeq: selectedIndex,
                devUserId: ''
            }
            fetch('api/Manager/GetDocBoxMember', {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json; charset=utf-8'
                },
                body: JSON.stringify(body)
            }).then((response) => response.json())
                .then((data) => {
                    setUserList(data.data.table);
                });
        }
    }, [selectedIndex]);

    useEffect(() => {
        setFilteredUsers(userList);
        setVeiwList(userList);
    }, [userList]);

    useEffect(() => {
        const docBoxName = groupList.find(group => group.docBoxSeq === selectedIndex)?.docBoxName || '';
        if(docBoxName)
            setListTitle(filteredUsers.length > 0 ? `${docBoxName} (${filteredUsers.length}명)` : docBoxName);
    }, [groupList, filteredUsers]);

    const checkExist = () => {
        if (groupList.find((group) => group.docBoxName === newGroup.name.trim())) {
            showToast("warning", "이미 존재하는 문서함 이름입니다.");
            return false;
        }
        if (groupList.find((group) => group.docBoxPath === newGroup.path.trim())) {
            showToast("warning", "이미 존재하는 키워드입니다.");
            return false;
        }
        return true;
    }

    const handleAddGroup = () => {
        if (!newGroup || !newGroup.name.trim() || !newGroup.path.trim()) return;
        if(checkExist()) {
            SaveUserAuthGroup('A', -1, newGroup.name, newGroup.path);
            setNewGroup(null);
        }
    };

    const handleDeleteGroup = (docBoxSeq) => {
        const userResponse = window.confirm("문서함을 삭제하시겠습니까?");
        if (userResponse) {
            SaveUserAuthGroup('D', docBoxSeq);
            setPopupContent(null);
        }
    };

    const handleEditGroup = (index) => {
        setEditingIndex(index);
        setEditName(index ? groupList[index].docBoxName : "");
        setPopupContent(null);
    };

    const handleSaveEdit = (index) => {
        if (!editName || editName.trim() === '') return;
        SaveUserAuthGroup('U', groupList[index].docBoxSeq, editName, groupList[index].docBoxPath);
        setEditingIndex(null);
    };

    const handleSelectGroup = (index) => {
        setIsCheckedAll(false);
        setCheckedItems(new Set());
        setSelectedIndex(index);
    };

    const SaveUserAuthGroup = (workingTag, docBoxSeq = -1, docBoxName = '', docBoxPath = '') => {
        fetch('api/Manager/SaveDocumentsBox', {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json; charset=utf-8'
            },
            body: JSON.stringify({
                workingTag: workingTag,
                devUserId: loginUserId,
                docBoxSeq: docBoxSeq,
                docBoxName: docBoxName,
                docBoxPath: docBoxPath
            })
        })
            .then(response => response.json())
            .then(data => {
                if (data.data.table) {
                    setGroupList(data.data.table);
                    if(workingTag === 'D') setSelectedIndex(-1);
                }
            })
            .catch(error => console.error('Error saveUserAuthGroup:', error));
    };

    const btnOnPopup = (e, item, index, type) => {
        setPopupContent(item !== null && item !== undefined
            ? renderMoreMenu(e, item, index, type) : null);
    }

    const [position, setPosition] = useState({ x: 0, y: 0 });
    
    const handleMouseDown = (event) => {
        setPosition({ x: event.clientX, y: event.clientY });
    };

    const renderMoreMenu = (e, item, index, type) => {
        if (type === "box") {
            return (<div className="context-menu" style={{ top: e.clientY + 'px', left: e.clientX + 'px' }}>
                        <ul>
                            <li onClick={() => handleEditGroup(index)}><a className='default'>문서함 이름 변경</a></li>
                            <li onClick={() => handleDeleteGroup(item)}><a className="nega">삭제</a></li>
                        </ul>
                    </div>
            );
        }
        return (
            <div className="layer-list admin-more-menu" style={{ top: e.clientY + 'px', left: e.clientX + 'px' }}>
                <div className="box">
                    <ul>
                        <li><a onClick={e => updateIsAdmin(item, index)}>{item.isAdmin ? "관리자 해제" : "관리자 설정"}</a></li>
                    </ul>
                </div>
            </div>
        );
    }

    const updateIsAdmin = (item, index) => {
        const isUpdate = window.confirm(`${item.devUserName} 사용자를 관리자 ${item.isAdmin ? "해제" : "설정"}하시겠습니까?`);
        if(!isUpdate) {
            setPopupContent(null);
            return;
        }
        const workingData = [{ workingTag: 'U', devUserId: loginUserId, docBoxSeq: selectedIndex, docBoxMemberId: item.devUserId, isAdmin: item.isAdmin ? 0 : 1 }];
        saveUserAuthGroupMember(workingData);
    }

    const renderUserList = () => {
        let list = [];
        for (let i = 0; i < filteredUsers.length; i++) {
            list.push(
                <tr key={i}>
                    <td onClick={(e) => checkHandler(i)}><div className="list-checkbox"><input type="checkbox" id={"chk" + i} value={i} checked={checkedItems.has(i)} onChange={() => checkHandler(i)} /><label htmlFor={"chk" + i}></label></div></td>
                    <td>{filteredUsers[i].devUserName}</td>
                    <td>{filteredUsers[i].devUserId}</td>
                    <td>{filteredUsers[i].deptName ?? ""}</td>
                    <td>{filteredUsers[i].companyName}</td>
                    <td>{filteredUsers[i].isAdmin ? "O" : "X"}</td>
                    <td><button className="btn-admin-more" onClick={e => btnOnPopup(e, filteredUsers[i], i, 'user')}><i className="i-btn-more"></i></button></td>
                </tr>
            );
        }
        return list;
    }
    const list = renderUserList();
    const allCheckedHandler = (e) => {
        const isChecked = e.target.checked;
        setIsCheckedAll(isChecked);

        setCheckedItems(isChecked ? new Set(filteredUsers.map((_, i) => i)) : new Set());
    };

    const checkHandler = (index) => {
        setCheckedItems((prev) => {
            const newChecked = new Set(prev);
            newChecked.has(index) ? newChecked.delete(index) : newChecked.add(index);

            setIsCheckedAll(newChecked.size === filteredUsers.length);
            return newChecked;
        });
    };
    const setHeaders = () => {
        return [
            <div className="list-checkbox"><input type="checkbox" id="chkAll" checked={isCheckedAll} onChange={(e) => allCheckedHandler(e)} /><label htmlFor="chkAll"></label></div>,
            "이름",
            "이메일 아이디",
            "부서",
            "소속",
            "관리자",
            ""
        ];
    };
    const renderBatchWrap = () => {
        let batchWrapArr = [];
        batchWrapArr.push(
            <p key="batch" className="count"><span className="selected">{checkedItems.size}</span>/{filteredUsers.length} 선택됨</p>
        );
        return batchWrapArr;
    }

    const saveUserAuthGroupMember = (workingData) => {
        fetch('api/Manager/SaveDocBoxMember', {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json; charset=utf-8'
            },
            body: JSON.stringify(workingData)
        })
            .then(response => response.json())
            .then(data => {
                if (data.data) {
                    showToast('success', '저장이 완료되었습니다.', 3000);
                    setUserList(data.data);
                    setIsCheckedAll(false);
                    setCheckedItems(new Set());
                    setPopupContent(null);
                }
            })
            .catch(error => console.error('Error saveUserAuthGroupMember:', error));
    };

    const openAddGroupMemberPopup = () => {
        setPopupContent(
            <AddGroupMember
                onClose={setPopupContent}
                docBoxUserList={filteredUsers}
                docBoxSeq={selectedIndex}
                saveUserAuthGroupMember={saveUserAuthGroupMember}
                loginUserId={loginUserId}
            />
        );
    };

    const removeGorupMember = () => {
        let workingData = [];
        checkedItems.forEach(item => {
            workingData.push({ workingTag: 'D', devUserId: loginUserId, docBoxSeq: selectedIndex, docBoxMemberId: filteredUsers[item].devUserId, isAdmin: filteredUsers[item].isAdmin });
        });
        saveUserAuthGroupMember(workingData);
    }
    return (
        <div className="content-scroll" onMouseDown={handleMouseDown}>
            <div className="content">
                <div className="content-left">
                    <div className="list-top">
                        <h3 className='list-title'>에디터 문서함</h3>
                        <button className='btn-add' onClick={() => setNewGroup({name:'', path:''})}>
                            <i className='icoKdc24 add-24'></i>
                        </button>
                    </div>
                    <ul className='group-list' style={{ overflowY: "scroll" }}>
                        {groupList.map((group, index) => (
                            <li className={`group-item ${selectedIndex === group.docBoxSeq ? 'selected' : ''}`} key={group.docBoxSeq} onClick={() => handleSelectGroup(group.docBoxSeq)}>
                                <div className="group-name-wrap">
                                    <i className='icoKdc24 parcel-24'></i>
                                    {editingIndex === index ? (
                                        <input type="text" value={editName} onChange={(e) => setEditName(e.target.value)} autoFocus placeholder="문서함 이름을 입력하세요" style={{borderBottom: "1px solid #eaeaea"}}/>
                                    ) : (
                                        <p className='group-name'>{group.docBoxName}</p>
                                    )}
                                </div>
                                {editingIndex === index ? (
                                    <>
                                        <button className="btn-add" onClick={() => handleEditGroup(null)}>취소</button>
                                        <button className="btn-add" onClick={() => handleSaveEdit(index)}>확인</button>
                                    </>
                                ) : (
                                    <button onClick={e => btnOnPopup(e, group.docBoxSeq, index, "box")}>
                                        <i className='icoKdc24 kebab-24'></i>
                                    </button>
                                )}
                            </li>
                        ))}
                        {newGroup !== null && (
                            <li className='group-item'>
                                <div className="group-name-wrap" style={{width:"80%"}}>
                                    <i className="icoKdc24 parcel-24"></i>
                                    <input type="text" style={{width:"40%", fontSize:"14px", borderBottom: "1px solid #eaeaea"}} name="name" value={newGroup.name} onChange={(e) => setNewGroup(prev => {return {...prev, name: e.target.value}})} autoFocus placeholder="문서함 이름" />
                                    <input type="text" style={{width:"40%", fontSize:"14px", borderBottom: "1px solid #eaeaea"}} name="path" value={newGroup.path} onChange={(e) => setNewGroup(prev => {return {...prev, path: e.target.value.replace(/[^A-Za-z]/ig, '').toLowerCase()}})} placeholder="키워드(영문)" />
                                </div>
                                <button className="btn-cancel" onClick={() => setNewGroup(null)}>취소</button>
                                <button className="btn-add" onClick={handleAddGroup}>확인</button>
                            </li>
                        )}
                    </ul>
                </div>
                <div className="content-right">
                    <h3 className='list-title mb-12'>{listTitle}</h3>
                    <div className="list-tools">
                        <div className={`btns-wrap ${selectedIndex === -1 ? "dis" : ""}`}>
                            <button className='btn-appr' onClick={openAddGroupMemberPopup}>
                                <i className='icoKdc12 add-12'></i>사용자 추가
                            </button>
                            <button className='btn-rjct' onClick={removeGorupMember}>사용자 삭제</button>
                            {checkedItems.size > 0 ? renderBatchWrap() : null}
                        </div>
                        <Filter key={0}
                            listData={veiwList}
                            setListView={setFilteredUsers}
                            // multiKeywords={[{ name: "companyName", title: "소속" }]}
                            searchKeyword={{ name: ["devUserId", "devUserName"], title: "이름 또는 아이디로 검색" }}
                        />
                    </div>
                    <Table className={"userlist"} headers={setHeaders()} list={list} />
                    <PopUp setContent={() => btnOnPopup()} content={popupContent} />
                </div>
            </div>
        </div>
    );
};

const AddGroupMember = (props) => {
    const [editorList, setEditorList] = useState([]);
    const [searchValue, setSearchValue] = useState('');
    const [matchedUsers, setMatchedUsers] = useState([]);
    const [userListState, setUserListState] = useState([]);
    const [workingData, setWorkingData] = useState([]);

    const splitKorean = (text) => text.normalize('NFD').replace(/[\u314e-\u314f\u1160-\u1161]/g, '');

    useEffect(() => {
        getEditorList();
    }, []);

    const getEditorList = async () => {
        const response = await fetch(`api/Manager/GetEditor`, {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json; charset=utf-8'
            }
        });
        const result = await response.json();
        setEditorList(result.data.table.filter(editor => 
            !props.docBoxUserList.some(user => user.devUserId === editor.devUserId)
        ));
    };

    const handleKeyUp = () => {
        const trimmedValue = searchValue.trim();
        if (trimmedValue !== '') {
            const matched = editorList.filter(user => {
                const devUserName = splitKorean(user.devUserName).toLowerCase();
                const searchText = splitKorean(trimmedValue).toLowerCase();
                return devUserName.includes(searchText);
            });
            setMatchedUsers(matched.slice(0, 5));
        } else {
            setMatchedUsers([]);
        }
    };

    const handleKeyDown = (e) => {
        if (e.key === 'Enter') {
            e.preventDefault();
            if (matchedUsers.length === 1) {
                addUserToList(matchedUsers[0]);
            }
        }
    };

    const handleInputChange = (e) => {
        setSearchValue(e.target.value);
    };

    const addUserToList = (user) => {
        if (!userListState.some(u => u.devUserId === user.devUserId)) {
            setUserListState([...userListState, user]);
            setWorkingData(prev => [...prev, { workingTag: 'A', devUserId: props.loginUserId, docBoxSeq: props.docBoxSeq, docBoxMemberId: user.devUserId, isAdmin: 0 }]);
        }
        setSearchValue('');
        setMatchedUsers([]);
    };

    const removeUserFromList = (index) => {
        const userToRemove = userListState[index];
        setWorkingData(prev => prev.filter(item => item.docBoxMemberId !== userToRemove.devUserId));
        setUserListState(userListState.filter((_, i) => i !== index));
    };

    return (
        <div className="msg-popup center-box overflow-unset">
            <div className="modal">
                <div className="modal-top">
                    <h3 className="modal-title">문서함 멤버 추가</h3>
                    <button className="btn-close" onClick={() => props.onClose(null)}>
                        <i className="icoKdc32 close"></i>
                    </button>
                </div>
                <div className="modal-cnts">
                    <form className="search-input" onKeyUp={handleKeyUp} onKeyDown={handleKeyDown}>
                        <i className="icoKdc20 add-g"></i>
                        <input
                            placeholder="사용자 이름을 입력하세요."
                            value={searchValue}
                            onChange={handleInputChange}
                        />
                    </form>
                    {matchedUsers.length > 0 && (
                        <div className="matched-users">
                            <ul className="user-list">
                                {matchedUsers.map((user, index) => (
                                    <li key={index} onClick={() => addUserToList(user)}>
                                        {`${user.devUserName} (${user.companyName || user.companyName}) <${user.devUserId}>`}
                                    </li>
                                ))}
                            </ul>
                        </div>
                    )}
                    <div className="mail-list-wrap">
                        <p className="mail-list-label">사용자</p>
                        <ul className="mail-list">
                            {userListState.map((user, index) => (
                                <li key={index}>
                                    <p className="user-name">{`${user.devUserName} (${user.companyName || user.companyName}) <${user.devUserId}>`}</p>
                                    <button className="btn-delete" onClick={() => removeUserFromList(index)}>
                                        <i className="icoKdc12 delete"></i>
                                    </button>
                                </li>
                            ))}
                        </ul>
                    </div>
                </div>
                <div className="mail-list-btm">
                    <button className="btn-share" onClick={() => props.saveUserAuthGroupMember(workingData)}>
                        완료
                    </button>
                </div>
            </div>
        </div>
    );
};

export default EditorSetting;